import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { NumericDirective } from '../../../directives/numeric.directive';

@Component({
    selector: 'app-multi-field-duration-picker',
    templateUrl: './multi-field-duration-picker.component.html',
    styleUrls: ['./multi-field-duration-picker.component.scss'],
    standalone: true,
    imports: [ReactiveFormsModule, NumericDirective]
})
export class MultiFieldDurationPickerComponent implements OnInit {
  @Input() public form: UntypedFormGroup;

  constructor() { }

  ngOnInit() {
  }

}
